import { call, put, takeLatest } from 'redux-saga/effects';

import { getAccountSignList } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getAccountSignList, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* accountSignListSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
